// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraNumeric } from './TerceraNumeric';
export class QuickTableNumeric extends TerceraNumeric {
    constructor(initProps, data, callback, rect) {
        super();
        const editingInfo = data.cell.QuickTableEditingInfo;
        this._initData = {
            minValue: editingInfo.Min,
            maxValue: editingInfo.Max,
            step: editingInfo.Inc,
            decimalPrecision: editingInfo.DecimalPlaces,
            value: data.cell.value
        };
        this.tag = data;
        this.callBack = callback;
        this.setBounds(rect.X, rect.Y, rect.Width, rect.Height);
    }
    oncomplete() {
        super.oncomplete();
        void this.set(Object.assign(Object.assign({}, this._initData), { isPosAbsolute: true }));
        this.setFocus();
    }
    processEnterKeyDown() {
        this.lostFocus();
    }
    lostFocus() {
        super.lostFocus();
        this.callBack(this.get('value'), this.tag);
    }
}
TerceraNumeric.extendWith(QuickTableNumeric, {
    data: function () {
        return {
            additionalClass: 'table-numeric'
        };
    }
});
